import { SHOW_SPINNER } from "../constants/Wrapper/Spinner";

export const spinnerMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case "FETCH_LOGIN_REQUEST":
      store.dispatch({
        type: SHOW_SPINNER,
        payload: true,
      });
      break;

    case "PAYMENT_CANCEL_SUCCESS":
      store.dispatch({
        type: SHOW_SPINNER,
        payload: false,
      });
      break;
    default:
      break;
  }
  next(action);
};
